import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home, Calendar, Mail, Phone } from 'lucide-react';
import Header from '../../common/Header';
import Footer from '../../common/Footer';
const BookingSuccess = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleBookAnother = () => {
    navigate('/doctors');
  };

  return (
    <>
    <Header />
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
          {/* Success Header */}
          <div className="bg-gradient-to-r from-green-600 to-emerald-600 px-8 py-12 text-white text-center">
            <div className="flex items-center justify-center w-20 h-20 bg-white bg-opacity-20 rounded-full mx-auto mb-6 animate-bounce">
              <CheckCircle className="h-10 w-10" />
            </div>
            <h1 className="text-3xl font-bold mb-4">
              Appointment Confirmed! 🎉
            </h1>
            <p className="text-green-100 text-lg">
              Your appointment has been successfully booked
            </p>
          </div>

          {/* Success Content */}
          <div className="px-8 py-12">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="h-8 w-8 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                What's Next?
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                We've sent you a confirmation message with all the appointment details. 
                Please arrive 15 minutes early for your appointment.
              </p>
            </div>

            {/* Next Steps */}
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-4 p-4 bg-blue-50 rounded-xl">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Check Your Email</h3>
                  <p className="text-gray-600 text-sm">
                    Confirmation details sent to your registered email
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-purple-50 rounded-xl">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone className="h-5 w-5 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">SMS Reminder</h3>
                  <p className="text-gray-600 text-sm">
                    You'll receive a reminder message before your appointment
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-green-50 rounded-xl">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Calendar className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Add to Calendar</h3>
                  <p className="text-gray-600 text-sm">
                    Don't forget to add this appointment to your personal calendar
                  </p>
                </div>
              </div>
            </div>

            {/* Important Note */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-yellow-600 text-sm font-bold">!</span>
                </div>
                <div>
                  <h3 className="font-semibold text-yellow-800 mb-2">Important Reminders</h3>
                  <ul className="text-yellow-700 text-sm space-y-1">
                    <li>• Please arrive 15 minutes before your appointment time</li>
                    <li>• Bring a valid ID and any relevant medical documents</li>
                    <li>• Contact us if you need to reschedule or cancel</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4">
              <button
                onClick={handleGoHome}
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
              >
                <Home className="h-5 w-5" />
                Go to Homepage
              </button>
              
              <button
                onClick={handleBookAnother}
                className="w-full bg-white hover:bg-gray-50 text-blue-600 font-semibold py-4 px-6 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 border-2 border-blue-600 hover:border-blue-700"
              >
                <Calendar className="h-5 w-5" />
                Book Another Appointment
              </button>
            </div>
          </div>
        </div>

        {/* Support Contact */}
        <div className="mt-8 text-center">
          <p className="text-gray-600">
            Need help? Contact our support team at{' '}
            <a href="tel:+1234567890" className="text-blue-600 hover:text-blue-800 font-semibold">
              +1 (234) 567-890
            </a>
          </p>
        </div>
      </div>
    </div>
    <Footer />
      </>
  );
};

export default BookingSuccess;